<template>
    <div>
        <template v-if="editable">
            <slot name="label">
                <span :class="labelClass">{{label}}</span>
            </slot>
            <slot name="text-field">
                <v-autocomplete
                    v-if="type == 'autocomplete'"
                    v-bind="$attrs"
                    :value="value"
                    :items="items"
                    no-data-text="該当項目なし"
                    @input="v => $emit('input', v)"
                />
                <v-text-field
                    v-else-if="type!='password'"
                    v-bind="$attrs"
                    :value="value"
                    :type="type"
                    :onpaste="'return '+(!cannotPaste).toString()"
                    :oncopy="'return '+(!cannotCopy).toString()"
                    :oncontextmenu="'return '+(!cannotContextMenu).toString()"
                    @input="v => $emit('input', v)"
                />
                <v-text-field
                    v-else
                    v-bind="$attrs"
                    :value="value"
                    :onpaste="'return '+(!cannotPaste).toString()"
                    :oncopy="'return '+(!cannotCopy).toString()"
                    :oncontextmenu="'return '+(!cannotContextMenu).toString()"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    @input="v => $emit('input', v)"
                    @click:append="showPassword = !showPassword"
                />
            </slot>
        </template>
        <template v-else>
            <div class="text-body-2">{{label}}</div>
            <div>{{text ? text : 'なし'}}</div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'TextField',
    inheritAttrs: false,
    model: {
        prop: 'value'
    },
    data(){
        return {
            showPassword: false
        }
    },
    props:{
        editable: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        labelClass: {
            type: String,
            default: "text-body-2"
        },
        type: {
            type: String,
            default: 'text'
        },
        'cannot-paste': {
            type: Boolean,
            default: false
        },
        'cannot-copy': {
            type: Boolean,
            default: false
        },
        'cannot-context-menu': {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            default: () => []
        },
    },
    computed: {
        text: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
}
</script>
